export default __webpack_public_path__ + "static/media/army_113.8b51ea4a.jpg";